/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum VinCheckStatus {
  CREATED = 'Created',
  DUPLICATE_FOR_REGISTRATION = 'DuplicateForRegistration',
  EXISTS_AT_ANOTHER_REGISTRATION = 'ExistsAtAnotherRegistration',
}
